const initialState = {
  count: 0,
};

export default initialState;
